// extracted by mini-css-extract-plugin
module.exports = {"actions":"seance-actions_actions__2CAFW","actionsWrap":"seance-actions_actionsWrap__2bpJr"};